import { KeyboardEvent, MouseEvent } from "react"
import styled from "styled-components"

import { TextArea, TextAreaProps } from "@minuthq/meatball-ui-react"

import { spacing } from "src/ui/spacing"

export function TextEditor({
  toolbar,
  onCaretMoved,
  ...props
}: {
  toolbar?: React.ReactNode
  onCaretMoved?: (pos: number) => void
} & TextAreaProps) {
  function handleCaret(
    e: MouseEvent<HTMLTextAreaElement> | KeyboardEvent<HTMLTextAreaElement>
  ) {
    const selectionStart = (e.target as HTMLTextAreaElement).selectionStart
    if (selectionStart != null) {
      onCaretMoved?.(selectionStart)
    }
  }

  return (
    <div>
      {!!toolbar && <Toolbar>{toolbar}</Toolbar>}
      <TextArea
        minRows={7}
        maxRows={7}
        onClick={handleCaret}
        onKeyUp={handleCaret}
        {...props}
      />
    </div>
  )
}

const Toolbar = styled.div`
  display: flex;
  margin-bottom: ${spacing.XS};
`
